import NewReleases from "@mui/icons-material/NewReleases";
import { Button } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const WhatsNew: FC = () => {
  const { t } = useTranslation();

  return (
    <Button
      size="small"
      sx={{ color: "text.sidebar", p: 0 }}
      data-analytics-id="sidebar-whats-new"
      variant="text"
      startIcon={<NewReleases />}
      href="https://help.changeengine.com/articles/2026-product-updates-yeFMukDi6a"
      target="_blank"
    >
      {t("What's new?")}
    </Button>
  );
};
